import React, { PropsWithChildren } from 'react';
import { SurveyLoader } from '../SurveyLoader/SurveyLoader';

type SurveyButtonProps = {
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => Promise<void> | void;
};

export const SurveyButton: React.FC<PropsWithChildren<SurveyButtonProps>> = ({
  className,
  children,
  onClick,
  disabled,
  loading,
}) => {
  return (
    <button className={className} type="button" onClick={onClick} disabled={disabled || false}>
      {!loading ? children : <SurveyLoader isLoading />}
    </button>
  );
};
